module.exports = __webpack_public_path__ + "static/media/README.508a50c4.md";